import { stringEnum } from '@/models/type-generators/string-enum';

export type Environment = 'DEV' | 'QA' | 'UAT1' | 'PREP';
export const Environment = stringEnum<Environment>();
